/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Rest_Plus_LabelInputs */

const en_us2_workout_rest_plus_label = /** @type {(inputs: Workout_Rest_Plus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 more seconds of rest`)
};

const pt_br2_workout_rest_plus_label = /** @type {(inputs: Workout_Rest_Plus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais 15 segundos de descanso`)
};

const es_419_workout_rest_plus_label = /** @type {(inputs: Workout_Rest_Plus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 segundos más de descanso`)
};

const pt_pt2_workout_rest_plus_label = /** @type {(inputs: Workout_Rest_Plus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais 15 segundos de descanso`)
};

const fr_fr2_workout_rest_plus_label = /** @type {(inputs: Workout_Rest_Plus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 secondes de repos en plus`)
};

const de_de2_workout_rest_plus_label = /** @type {(inputs: Workout_Rest_Plus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 Sekunden mehr Pause`)
};

const it_it2_workout_rest_plus_label = /** @type {(inputs: Workout_Rest_Plus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 secondi di recupero in più`)
};

/**
* | output |
* | --- |
* | "15 more seconds of rest" |
*
* @param {Workout_Rest_Plus_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_rest_plus_label = /** @type {((inputs?: Workout_Rest_Plus_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Rest_Plus_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_rest_plus_label(inputs)
	if (locale === "es-419") return es_419_workout_rest_plus_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_rest_plus_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_rest_plus_label(inputs)
	if (locale === "de-DE") return de_de2_workout_rest_plus_label(inputs)
	if (locale === "it-IT") return it_it2_workout_rest_plus_label(inputs)
	return en_us2_workout_rest_plus_label(inputs)
});
export { workout_rest_plus_label as "workout.rest_plus_label" }